import * as uuid from 'uuid';
import { ISettingsStore } from './settings-store';
import { HttpClient } from '@angular/common/http';
import { concatMap, map, filter, defaultIfEmpty } from 'rxjs/operators';
import { Observable } from 'rxjs';
import { RequestDataAccessServiceConfig } from '../request-data-access.service';
import { CredentialsFactory } from 'authorization';
import { CouchDbRepository } from '../base/couchdb-repository';

class SettingDoc {
  constructor(id: string, key: string, value: string, rev: string) {
    this._id = id;
    this.key = key;
    this.value = value;
    this.rev = rev;
  }
  readonly _id: string;
  readonly key: string;
  readonly value: string;
  readonly rev: string;
}

export class CouchDbSettingsStore implements ISettingsStore {
  private readonly _repo: CouchDbRepository<SettingDoc>;
  constructor(
    private _httpClient: HttpClient,
    private readonly _configuration: RequestDataAccessServiceConfig,
    private readonly _credentialsFactory: CredentialsFactory,
  ) {
    this._repo = new CouchDbRepository<SettingDoc>(
      (x) => x._id,
      (x) => new SettingDoc(x._id, x.key, x.value, x._rev),
      'global_settings',
      this._httpClient,
      this._configuration,
      this._credentialsFactory,
    );
  }

  getSetting$(key: string): Observable<string | null> {
    return this._repo.getAll$().pipe(
      filter((x) => x.key === key),
      map((x) => x.value),
    );
  }

  setSetting$(settingKey: string, value: string): Observable<boolean> {
    return this._repo.getAll$().pipe(
      filter((x) => x.key === settingKey),
      defaultIfEmpty(new SettingDoc(uuid.v4().toString(), settingKey, value, '')),
      concatMap((x) => {
        return this._repo.store$(new SettingDoc(x._id, x.key, value, x.rev)).pipe(map((x) => !!x));
      }),
    );
  }
}
